import axios from "axios";
import { ServerSideTypes } from "../common/OperationCommonTypes";
import EquipmentKitTypes from "../equipment/equipmentKit/Types";
import { EquipmentAssociationTypes } from "./Types";

export namespace EquipmentAssociationRequests {
  export interface GetAll {
    acrissId?: string;
    equipmentKitId?: string;
  }

  export interface Create {
    ids: number[];
    equipmentKitsId: number[];
  }

  export interface Edit {
    ids: number[];
    equipmentKitsId: number[];
  }
}

const EquipmentAssociationService = {
  get: {
    filterAcriss: (tenant:string,data: EquipmentAssociationRequests.GetAll, serverParams: ServerSideTypes.IParams) => {
      return axios.get<ServerSideTypes.IResult<EquipmentAssociationTypes.ACRISS>>("masterdatavehicle/acriss", { params: {tenant,...data, ...serverParams} }).then(
        response => response.data,
      )
    },
    allAcriss: (tenant:string) => {
      return axios.get<EquipmentAssociationTypes.ACRISS[]>("masterdatavehicle/acriss/all",{params:{tenant:tenant}}).then(
        response => response.data,
      )
    },
    allKits: (tenant:string) => {
      return axios.get<EquipmentAssociationTypes.Kit[]>("masterdatavehicle/equipmentkit/all",{params:{tenant:tenant}}).then(
        response => response.data,
      )
    },
    acrissKitsById: (tenant:string,id: number) => {
      return axios.get<EquipmentAssociationTypes.Kit[]>(`masterdatavehicle/acriss/${id}/equipmentkit/all`,{params:{tenant:tenant}}).then(
        response => response.data,
      );
    },
    selectedKits: (tenant:string,id: string, serverParams: ServerSideTypes.IParams) => {
      const emptyResponse = {"content":[],"pageNumber":0,"pageSize":10,"totalElements":0,"totalPages":0};
      if (!id) { return Promise.resolve(emptyResponse); }
      return axios.get<ServerSideTypes.IResult<EquipmentAssociationTypes.Kit>>(`masterdatavehicle/acriss/${id}/equipmentkit`, { params: {tenant, ...serverParams} }).then(
        response => response.data,
      ).catch(() => {
        return emptyResponse;
      })
    },
  },
  put: {
    create: (tenant:string,data: EquipmentAssociationRequests.Create) => {
      return axios.put("masterdatavehicle/acriss/equipmentkit", undefined, {
        params: {
          tenant:tenant,
          ids: data.ids.join(","),
          equipmentKitsId: data.equipmentKitsId.join(","),
        }
      }).then(
        response => response.data,
      )
    },
    edit: (tenant:string,data: EquipmentAssociationRequests.Edit) => {
      return axios.put("masterdatavehicle/acriss/equipmentkit", undefined, {
        params: {
          tenant:tenant,
          ids: data.ids.join(","),
          equipmentKitsId: data.equipmentKitsId.join(","),
        }
      }).then(
        response => response.data,
      )
    },
    detachKit: (tenant:string,id: number, kitId: number) => {
    return axios.put(`masterdatavehicle/acriss/${id}/detachequipmentkit/${kitId}`,undefined, {params:{tenant:tenant}}).then(
        response => response.data
      )
    }
  }
};

export default EquipmentAssociationService;